import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import NativeFontSizeInput from './';

function NativeFontSizeInputReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeFontSizeInputReference = useRef(null);

  useEffect(function onLoad() {

    const container = wrapperMainReference.current;

    const nativeFontSizeInput = new NativeFontSizeInput(props);

    nativeFontSizeInputReference.current = nativeFontSizeInput;

    mount(container, nativeFontSizeInputReference.current);

    return function onUnload() {

      unmount(container, nativeFontSizeInput);

    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativeFontSizeInputReference.current.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'font-size-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeFontSizeInputReactWrapper;